import "./Footer.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FaInstagram, FaFacebook } from "react-icons/fa";
import { ArrowUpOutlined } from "@ant-design/icons";

function Footer(props) {
  return (
    <div className="footer_container">

      {/* ── Contact ── */}
      <div className="row gx-0" style={{ justifyContent: "center" }}>
        <div className="footer_title">
          <div>Contact</div>
        </div>
      </div>
      <div className="row gx-0">
        <div className="col-9 col-xl-8 col-lg-10 col-md-10">
          <div className="row gx-0 service_contact">
            <div className="col-4">
              <div className="footer_body_content">담당자 이메일</div>
              <div className="footer_body_content_und block_2">
                contact@deeptrade.co
              </div>
            </div>
            <div className="col-4">
              <div className="footer_body_content">오시는 길</div>
              <div className="footer_body_content_und block_3">
                <div>
                  <div>서울시 관악구 관악로1,</div>
                  <div>서울대학교 컴퓨터연구소(138동) 314호</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="up_arrow"
        onClick={() => {
          props.mainRef.current.scrollIntoView();
        }}
      >
        <ArrowUpOutlined style={{ color: "white", fontSize: 20, cursor: "pointer" }} />
      </div>
    </div>
  );
}

export default Footer;
